import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router'
import keymaster from 'keymaster';
import moment from 'moment';
import roles from '../utils/roles';
import * as list from '../utils/list';

import LogEntryDayListWidget from './LogEntryDayListWidget';
import LogOverviewHeaderForEditLogs from './LogOverviewHeaderForEditLogs';

import floatingTaskActions from '../actions/floatingTaskActionCreators';
import * as logEntryActions from '../actions/logEntryActionCreators';
import projectActions from '../actions/projectActionCreators';
import taskActions from '../actions/taskActionCreators';
import timesheetActions from '../actions/timesheetActionCreators';
import userActions from '../actions/userActionCreators';
import Time from "../utils/time";

require.ensure([], () => {
    require('./LogOverview.less');
    require('./Material-Design-Iconic.less');
});

class EditLogs extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.day = [];
        this.state = {
            date: moment().day(1),
            logEntriesByDate: [[], [], [], [], [], [], []]
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.currentUser) {
            //way to transition to root using react-router if user has no roles
            if(!roles.userHasAnyOfRoles(nextProps.currentUser, ['PMO'])) {
                browserHistory.push('/');
            }
        }

        let logEntriesByDate = this.mapLogEntriesByDate(nextProps.logEntriesOnWeekForUser);

        if ((nextProps.selectedUser && !this.state.user) ||
            (nextProps.selectedUser && this.state.user && this.state.user.id != nextProps.selectedUser.id)) {
            let user = nextProps.selectedUser;

            this.props.dispatch(logEntryActions.loadOnWeekForUser(this.state.date, user.id));
            this.props.dispatch(projectActions.loadByUser(user.id));
            this.props.dispatch(taskActions.loadByUser(user.id));
            this.loadTimesheetUser(user);
        }

        this.setState({
            logEntriesByDate: logEntriesByDate,
            user: nextProps.selectedUser
        });

        let queryParams = nextProps.location.query;
        let userID = queryParams.userID;
        let week = queryParams.week;

        // TODO ako se zeli promjeniti user-a, to nece biti moguce dok god je u query-u naveden userID jer ce neprestano siliti redux da selecta tog user-a
        if (!nextProps.selectedUser && userID) {
            let user = list.findByID(nextProps.users, userID);
            if (user) {
                this.props.dispatch(userActions.setSelectedUser(user));
                if (week)
                    this.handleExplicitQuery(week, user);
            }
        }

        if (nextProps.selectedUser && week) {
        }
    }

    mapLogEntriesByDate = (logEntriesOnWeekForUser) => {
        let logEntriesByDate = [[], [], [], [], [], [], []];
        for (let i = logEntriesOnWeekForUser.length - 1; i >= 0; i--) {
            let logEntryDate = moment(logEntriesOnWeekForUser[i].date, "YYYY-MM-DD");

            if (!this.state) break;

            let diff = logEntryDate.diff(moment(this.state.date.format("YYYY-MM-DD"), "YYYY-MM-DD"), 'days');

            if (diff < 0 || diff > 6) break;

            logEntriesByDate[diff].push(logEntriesOnWeekForUser[i]);
        }
        return logEntriesByDate;
    }

    componentDidMount = () => {
        moment.updateLocale('en', {
            week: { doy: 4 }
        });

        this.props.dispatch(projectActions.setCurrentView("EDIT_LOGS"));
        this.props.dispatch(floatingTaskActions.loadAll());
        this.props.dispatch(taskActions.pmoLoadAll());
        this.props.dispatch(userActions.loadRegularUsers());
        this.loadTimesheet();

        keymaster('left', this.decrementWeek);
        keymaster('right', this.incrementWeek);
    }

    componentWillUnmount = () => {
        keymaster.unbind('left');
        keymaster.unbind('right');
    }

    // EVENT HANDLERS

    // on selecting date with datepicker
    handleDateChange = (date) => {
        moment.updateLocale('en', {
            week: { doy: 4 }
        });

        if (!this.state.user) return;

        this.setState({
            date: moment(date, "YYYY-MM-DD").startOf('isoweek')
        }, () => {
            this.props.dispatch(logEntryActions.loadOnWeekForUser(this.state.date, this.state.user.id));
            this.loadTimesheet();
        });
    }

    handleExplicitQuery = (week, user) => {
        let date = moment(week, "YYYYWW").day(1);

        this.props.dispatch(logEntryActions.loadOnWeekForUser(date, user.id));
        this.props.dispatch(taskActions.loadByUser(user.id));

        this.setState({
            date: date,
            user: user
        }, this.loadTimesheet);
    }

    // OTHER METHODS

    closeAllPopovers = () => {
        for (let i = 0; i < 7; ++i) {
            this.day[i].closePopovers();
        }
    }

    decrementWeek = () => {
        if (!this.state.user) return;

        let date = this.state.date.subtract(7, 'days');

        this.changeStateOnWeekChange(date);
    }

    incrementWeek = () => {
        if (!this.state.user) return;

        let date = this.state.date.add(7, 'days');

        this.changeStateOnWeekChange(date);
    }

    changeStateOnWeekChange = (date) => {
        this.setState({
            date: date
        }, () => {
            this.props.dispatch(logEntryActions.loadOnWeekForUser(this.state.date, this.state.user.id));
            this.loadTimesheet();
        });
    }

    loadTimesheet = () => {
        if (this.state.user && this.state.date) {
            this.props.dispatch(timesheetActions.loadByUserWeek(this.state.user, Time.getFormattedYearAndWeek(this.state.date)));
        }
    }

    loadTimesheetUser = (selectedUser) => {
        this.props.dispatch(timesheetActions.loadByUserWeek(selectedUser, Time.getFormattedYearAndWeek(this.state.date)));
    }

    returnKeymaster = () => {
        keymaster.unbind('left');
        keymaster.unbind('right');
        keymaster('left', this.decrementWeek);
        keymaster('right', this.incrementWeek);
    }

    // RENDER METHOD

    render = () => {
        let dates = [
            this.state.date.clone(),
            this.state.date.clone(),
            this.state.date.clone(),
            this.state.date.clone(),
            this.state.date.clone(),
            this.state.date.clone(),
            this.state.date.clone()
        ];

        for (let i = 0; i < dates.length; ++i) {
            dates[i].add(i, 'days');
        }

        let timeSpent = 0;
        let overtimeSpent = 0;
        let regularTimeSpent = 0; // this is non-overtime non-floatingtask time spent

        for (let i = 0; i < dates.length; ++i) {
            let logEntries = this.state.logEntriesByDate[i];

            for (let j = 0; j < logEntries.length; ++j) {
                if (!logEntries[j].duration)
                    continue;

                if (!logEntries[j].overtime) {
                    regularTimeSpent += parseInt(logEntries[j].duration);
                    timeSpent += parseInt(logEntries[j].duration);
                } else {
                    overtimeSpent += parseInt(logEntries[j].duration);
                }
            }
        }

        let minutesLogged = parseFloat((timeSpent % 60).toFixed(0));
        let overtimeMinutesLogged = parseFloat((overtimeSpent % 60).toFixed(0));
        timeSpent = parseFloat(Math.trunc(timeSpent / 60));
        overtimeSpent = parseFloat(Math.trunc(overtimeSpent / 60));
        regularTimeSpent = parseFloat(Math.trunc(regularTimeSpent / 60));

        return (
            <div>
                <LogOverviewHeaderForEditLogs
                    date={this.state.date}
                    decrementWeek={this.decrementWeek}
                    endDay={dates[6]}
                    handleDateChange={this.handleDateChange}
                    hoursLogged={timeSpent}
                    incrementWeek={this.incrementWeek}
                    logEntries={this.props.logEntriesOnWeekForUser}
                    minutesLogged={minutesLogged}
                    overtimeHoursLogged={overtimeSpent}
                    overtimeMinutesLogged={overtimeMinutesLogged}
                    regularHoursLogged={regularTimeSpent}
                    ref={ref => this.header = ref}
                    returnKeymaster={this.returnKeymaster}
                    startDay={dates[0]}
                    timesheet={this.props.currentTimesheet}
                    user={this.state.user}
                    users={this.props.users}
                    />
                <br/>
                {
                    this.state.user ?
                    <div className="row week">
                        <div className="col-lg-6 first-half">
                            <div className="row">
                                <div className="col-sm-4">
                                    <LogEntryDayListWidget
                                        closeAllPopovers={this.closeAllPopovers}
                                        date={dates[0]}
                                        getDay = {(yourself) => {this.day[0] = yourself}}
                                        infoUserTask={this.props.infoUserTask}
                                        loadTimesheet={this.loadTimesheet}
                                        logEntries={this.state.logEntriesByDate[0]}
                                        pmoMode={true}
                                        returnKeymaster={this.returnKeymaster}
                                        tasks={this.props.tasks}
                                        timesheet={this.props.currentTimesheet}
                                        user={this.state.user}
                                        />
                                </div>
                                <div className="col-sm-4">
                                    <LogEntryDayListWidget
                                        closeAllPopovers={this.closeAllPopovers}
                                        date={dates[1]}
                                        getDay = {(yourself) => {this.day[1] = yourself}}
                                        infoUserTask={this.props.infoUserTask}
                                        loadTimesheet={this.loadTimesheet}
                                        logEntries={this.state.logEntriesByDate[1]}
                                        odd
                                        pmoMode={true}
                                        returnKeymaster={this.returnKeymaster}
                                        tasks={this.props.tasks}
                                        timesheet={this.props.currentTimesheet}
                                        user={this.state.user}
                                        />
                                </div>
                                <div className="col-sm-4">
                                    <LogEntryDayListWidget
                                        closeAllPopovers={this.closeAllPopovers}
                                        date={dates[2]}
                                        getDay = {(yourself) => {this.day[2] = yourself}}
                                        infoUserTask={this.props.infoUserTask}
                                        loadTimesheet={this.loadTimesheet}
                                        logEntries={this.state.logEntriesByDate[2]}
                                        pmoMode={true}
                                        returnKeymaster={this.returnKeymaster}
                                        tasks={this.props.tasks}
                                        timesheet={this.props.currentTimesheet}
                                        user={this.state.user}
                                        />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="row">
                                <div className="col-sm-4">
                                    <LogEntryDayListWidget
                                        closeAllPopovers={this.closeAllPopovers}
                                        date={dates[3]}
                                        getDay = {(yourself) => {this.day[3] = yourself}}
                                        infoUserTask={this.props.infoUserTask}
                                        loadTimesheet={this.loadTimesheet}
                                        logEntries={this.state.logEntriesByDate[3]}
                                        odd
                                        pmoMode={true}
                                        returnKeymaster={this.returnKeymaster}
                                        tasks={this.props.tasks}
                                        timesheet={this.props.currentTimesheet}
                                        user={this.state.user}
                                        />
                                </div>
                                <div className="col-sm-4">
                                    <LogEntryDayListWidget
                                        closeAllPopovers={this.closeAllPopovers}
                                        date={dates[4]}
                                        getDay = {(yourself) => {this.day[4] = yourself}}
                                        infoUserTask={this.props.infoUserTask}
                                        loadTimesheet={this.loadTimesheet}
                                        logEntries={this.state.logEntriesByDate[4]}
                                        pmoMode={true}
                                        returnKeymaster={this.returnKeymaster}
                                        tasks={this.props.tasks}
                                        timesheet={this.props.currentTimesheet}
                                        user={this.state.user}
                                        />
                                </div>
                                <div className="col-sm-4">
                                    <LogEntryDayListWidget
                                        closeAllPopovers={this.closeAllPopovers}
                                        date={dates[5]}
                                        getDay = {(yourself) => {this.day[5] = yourself}}
                                        halfHeight
                                        infoUserTask={this.props.infoUserTask}
                                        loadTimesheet={this.loadTimesheet}
                                        logEntries={this.state.logEntriesByDate[5]}
                                        pmoMode={true}
                                        returnKeymaster={this.returnKeymaster}
                                        tasks={this.props.tasks}
                                        timesheet={this.props.currentTimesheet}
                                        user={this.state.user}
                                        />
                                    <LogEntryDayListWidget
                                        closeAllPopovers={this.closeAllPopovers}
                                        date={dates[6]}
                                        getDay = {(yourself) => {this.day[6] = yourself}}
                                        halfHeight
                                        infoUserTask={this.props.infoUserTask}
                                        loadTimesheet={this.loadTimesheet}
                                        logEntries={this.state.logEntriesByDate[6]}
                                        pmoMode={true}
                                        returnKeymaster={this.returnKeymaster}
                                        tasks={this.props.tasks}
                                        timesheet={this.props.currentTimesheet}
                                        user={this.state.user}
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
                }
            </div>
        );
    }
}

EditLogs.contextTypes = {
    router: PropTypes.object.isRequired
};

EditLogs.propTypes = {
    currentTimesheet: PropTypes.object,
    currentUser: PropTypes.object,
    dispatch: PropTypes.func,
    infoUserTask: PropTypes.object,
    logEntriesOnWeekForUser: PropTypes.array,
    routeParams: PropTypes.object,
    tasks: PropTypes.array,
    users: PropTypes.array
};

const mapStateToProps = (state) => {
    return {
        currentTimesheet: state.timesheets.currentTimesheet,
        currentUser: state.users.currentUser,
        infoUserTask: state.userTasks.userTaskByID ? state.userTasks.userTaskByID.userTask : null,
        logEntriesOnWeekForUser: state.logEntries.logEntriesOnWeekForUser,
        selectedUser: state.users.selectedUser,
        tasks: state.tasks.tasks,
        users: state.users.regularUsers
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditLogs);



/** WEBPACK FOOTER **
 ** ./src/app/components/EditLogs.js
 **/